<p-dialog header="Column Settings" (onHide)="cancelSettings()" [(visible)]="display"
  [style]="{width: '550px'}" [modal]="true" [baseZIndex]="10000">
    <div class="card">
        <div class="p-d-flex">
            <div>
                <h6>Column Selection (Max 12)</h6>
            </div>
        </div>
        <div>
            <input type="text" class="inputStyle p-inputtext" pInputText placeholder="Search for fields"
            [(ngModel)]="listSearchInput">
        </div>
        <div cdkDropList [cdkDropListData]="tempCols" (cdkDropListDropped)="dropListCol($event)">
            <ng-container *ngFor="let section of tempCols; let idx = index">
            <div class="colList" cdkDrag (cdkDragStarted)="cdkDragStarted()" (cdkDragReleased)="cdkDragReleased()">
                <div (click)="toggleChilds(section)">
                    <h6 class="sectionLabel"><i class="pi p-mr-3" [ngClass]="{'pi-minus': !section?.hideChilds,'pi-plus': section?.hideChilds}"></i>{{section.name}}</h6>
                </div>
                <div *cdkDragPreview>
                    <h6 class="sectionLabel p-pl-3" style="min-width: 200px;">{{section.name}}</h6>
                </div>
                <div *ngIf="!section?.hideChilds && showContent" class="sub-columns" cdkDropList [cdkDropListData]="section.fields" (cdkDropListDropped)="dropCol($event)">
                    <ng-container
                        *ngFor="let col of section.fields | gblFilter: listSearchInput: 'labelname' ; let i = index">
                        <div class="colList" cdkDrag [cdkDragDisabled]="i === 0 || (col.isrequired && col.ischecked)" appendTo="body"
                        *ngIf="!col.fieldTypes || col.fieldTypes.fields.length">
                            <div class="p-d-flex"
                                *ngIf="(col.code !== 'emailAddress' && ['Lead', 'Account'].includes(currentModuleName)) ||
                                !['Lead', 'Account'].includes(currentModuleName)">
                                <i class="fa fa-bars p-mt-1" *ngIf="!(i === 0 || (col.isrequired && col.ischecked))"
                                style="margin-right: 10px; color:lightgray"></i>
                                <i class="fa fa-minus p-mt-1" *ngIf="(i === 0 || (col.isrequired && col.ischecked))"
                                style="margin-right: 10px; color:lightgray"></i>
                                <p-checkbox *ngIf="!col.fieldTypes" [(ngModel)]="col.ischecked" type="checkbox" binary="true" inputId="binary"
                                [disabled]="((!col.ischecked && maxNo) || (col.isrequired && col.ischecked && !col.custom))"
                                (onChange)="onChange($event.checked, col)" class="p-mr-2"></p-checkbox>
                                <span class="p-mt-1">{{col.labelname}}</span>
                                <button type="button" pButton pRipple class="p-button-text p-button-rounded p-button-plain p-ml-2"
                                [icon]="col.fieldTypes && col.fieldTypes.showChildrens ? 'pi pi-minus' : 'pi pi-plus'" *ngIf="col.fieldTypes && col.fieldTypes.fields && col.fieldTypes.fields.length"
                                (click)="showChild(col)" style="height: 20px; width: 20px;"></button>
                            </div>
                            <div *ngIf="col.fieldTypes && col.fieldTypes.showChildrens && col.fieldTypes && col.fieldTypes.fields.length">
                                <ul>
                                <li *ngFor="let childCol of col.fieldTypes.fields">
                                    <p-checkbox [(ngModel)]="childCol.ischecked" type="checkbox" binary="true" inputId="binary"
                                    [disabled]="((!childCol.ischecked && maxNo) || (childCol.isrequired && childCol.ischecked && !childCol.custom ))"
                                    (onChange)="onChange($event.checked, col, childCol)" class="p-mr-2"></p-checkbox>
                                    {{childCol.labelname}}
                                </li>
                                </ul>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>

        </ng-container>
        </div>
    </div>
  <ng-template pTemplate="footer">
    <p-button (click)="cancelSettings()" label="Cancel" styleClass="p-button-secondary"></p-button>
    <p-button (click)="saveSettings()" label="Save"></p-button>
  </ng-template>
</p-dialog>